import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IBaseResponse } from "../interface/IBaseResponse";
import { IMoveTrade } from 'src/components/common/MoveTrade/IMoveTrade';

enum TradeServiceEnum {
  getAllPhases = "get-all",
  phaseApprove = "approve",
  approveWithMessage = "approve-trade-phase-wf?mensagem=",
  rejectWithMessage = "reject?mensagem=",
  phaseReject = "reject",
  phaseReview = "review",
  moveTrade = "move",
  setArchiveTrade = "archive-trade?",
  setIgnoreFromQuoteFilter = "ignore-from-quote-filter?tradeId={tradeId}"
}

export default class TradePhaseService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/phase/");
  }

  public getAllPhases = async (): Promise<string[]> => await this.GET(TradeServiceEnum.getAllPhases);
  public putInPhaseApprove = async data => await this.PUT(TradeServiceEnum.phaseApprove, data);
  public putApproveWithMessage = async (message: string, data: { Id: number; Reason: string; FileKeyS3: any }) =>
    await this.PUT(TradeServiceEnum.approveWithMessage + message, data);
  public putRejectWithMessage = async (message: string, data: { Id: number; Reason: string; FileKeyS3: any }) => await this.PUT(TradeServiceEnum.rejectWithMessage + message, data);
  public putInPhaseReject = async data => await this.PUT(TradeServiceEnum.phaseReject, data);
  public putInPhaseReview = async data => await this.PUT(TradeServiceEnum.phaseReview, data);
  public moveTrade = async (request: IMoveTrade) => await this.PUT(TradeServiceEnum.moveTrade, request);
  public setArchiveTrade = async (data: { archiveOrNot: boolean; tradeId: number }): Promise<IBaseResponse> => await this.PUT(TradeServiceEnum.setArchiveTrade, data);
  public setIgnoreFromQuoteFilter = async (tradeId): Promise<IBaseResponse> => await this.PUT(TradeServiceEnum.setIgnoreFromQuoteFilter.replace("{tradeId}", tradeId));
}
